webpackJsonp([43],{

/***/ 1182:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionGroupManage_vue__ = __webpack_require__(2886);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21bb84a1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionGroupManage_vue__ = __webpack_require__(5079);
function injectStyle (ssrContext) {
  __webpack_require__(5065)
  __webpack_require__(5067)
  this["$style"] = __webpack_require__(5069)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21bb84a1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionGroupManage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21bb84a1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionGroupManage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionGroupSelectDemo_vue__ = __webpack_require__(2888);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75eab42e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionGroupSelectDemo_vue__ = __webpack_require__(5086);
function injectStyle (ssrContext) {
  __webpack_require__(5080)
  __webpack_require__(5082)
  this["$style"] = __webpack_require__(5084)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75eab42e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionGroupSelectDemo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75eab42e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionGroupSelectDemo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(73);

/***/ }),

/***/ 1698:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// let currentDisabled = []
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    value: {
      type: Array,
      default: []
    },
    disabled: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    host: {
      type: String
    }
  },
  data: function data() {
    return {
      activePermissionGroup: null,
      permissionGroupList: [],
      permissionList: [],
      permissionListMap: {},
      checkAll: false,
      isIndeterminate: false,
      currentDisabled: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    clientHeight: function clientHeight(state) {
      return state.clientHeight;
    }
  }), {
    height: function height() {
      var height = this.clientHeight - 250;
      if (height < 300) {
        height = 300;
      }
      return height;
    },
    currentValue: function currentValue() {
      return this.value;
    }
  }),
  watch: {
    disabled: function disabled(_disabled) {
      var _this = this;

      var unselectedPermissions = _.difference(this.currentDisabled, _disabled);
      var selectedPermissions = _.difference(_disabled, this.currentDisabled);
      this.permissionGroupList.forEach(function (group) {
        group.permission_ids.forEach(function (id) {
          if (unselectedPermissions.includes(id)) {
            _this.permissionListMap[id].disabled = false;
          } else if (selectedPermissions.includes(id)) {
            _this.permissionListMap[id].disabled = true;
          }
        });
      });
      this.currentDisabled = filter.copyJson(_disabled);
      this.handleCheckedChange();
    },
    activePermissionGroup: function activePermissionGroup() {
      this.handleCheckedChange();
    }
  },
  created: function created() {
    var _this2 = this;

    this.currentDisabled = filter.copyJson(this.disabled);
    request.all.common([request('getPermissionTable', { host: this.host, per_page: 666 }), request('getPermissionGroupTable', { host: this.host })]).then(function (res) {
      // 权限列表
      _this2.permissionList = res[0].data.data;
      _this2.permissionListMap = {};
      _this2.permissionList.forEach(function (permission) {
        permission.disabled = false;
        _this2.permissionListMap[permission.id] = permission;
      });
      // 权限组列表
      var permissionGroupList = res[1].data.data;
      // 处理权限组列表
      permissionGroupList.forEach(function (group) {
        group.permission_ids = [];
        group.permissions.forEach(function (_ref) {
          var id = _ref.id;

          group.permission_ids.push(id);
          // 锁定的权限
          if (_this2.currentDisabled.includes(id)) {
            _this2.permissionListMap[id].disabled = true;
          }
        });
      });
      _this2.permissionGroupList = permissionGroupList;
      // 默认活跃权限组
      _this2.activePermissionGroup = permissionGroupList[0];
    });
  },
  mounted: function mounted() {},

  methods: {
    getSelected: function getSelected(group) {
      var unSelected = _.difference(group.permission_ids, this.currentValue);
      return _.difference(group.permission_ids, unSelected);
    },
    onActivePermissionGroup: function onActivePermissionGroup(group) {
      this.activePermissionGroup = group;
    },
    onChange: function onChange(val, id) {
      if (val) {
        this.currentValue.push(id);
      } else {
        this.currentValue.splice(this.currentValue.indexOf(id), 1);
      }
      this.$emit('change', this.currentValue);
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      var _this3 = this;

      var isChange = false;
      this.activePermissionGroup.permission_ids.forEach(function (id) {
        // 不能是禁止操作的对象
        if (!_this3.permissionListMap[id].disabled) {
          if (val) {
            // 添加选择的权限
            if (!_this3.currentValue.includes(id)) {
              _this3.currentValue.push(id);
              isChange = true;
            }
          } else {
            // 移除选择的权限
            var index = _this3.currentValue.indexOf(id);
            if (index !== -1) {
              _this3.currentValue.splice(index, 1);
              isChange = true;
            }
          }
        }
      });
      if (isChange) {
        this.$emit('change', this.currentValue);
      }
      this.isIndeterminate = false;
    },
    handleCheckedChange: function handleCheckedChange() {
      var unSelected = _.difference(this.activePermissionGroup.permission_ids, this.currentValue);
      var checkedCount = this.activePermissionGroup.permission_ids.length - unSelected.length;
      this.checkAll = checkedCount === this.activePermissionGroup.permission_ids.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.activePermissionGroup.permission_ids.length;
    }
  }
});

/***/ }),

/***/ 2062:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionGroupSelect_vue__ = __webpack_require__(1698);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ad5bbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionGroupSelect_vue__ = __webpack_require__(2069);
function injectStyle (ssrContext) {
  __webpack_require__(2063)
  __webpack_require__(2065)
  this["$style"] = __webpack_require__(2067)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46ad5bbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionGroupSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ad5bbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionGroupSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2063:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2064);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1d25ddee", content, true, {});

/***/ }),

/***/ 2064:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".permission-group .permission-group-panel{border:1px solid #ebeef5;border-radius:4px}.permission-group .permission-group-panel .permission-group-header{color:#303133;background-color:#f2f6fc;font-size:15px;padding:14px 10px;border-bottom:1px solid #ebeef5;position:relative}.permission-group .permission-group-panel .permission-group-header .permission-group-header-button{position:absolute;right:10px;top:2px}.permission-group .permission-group-panel .permission-group-left{height:100%;border-right:1px solid #ebeef5}.permission-group .permission-group-panel .permission-group-left .el-card__body{padding:0}.permission-group .permission-group-panel .permission-group-left .permission-group-list{padding:0;margin:0;list-style-type:none}.permission-group .permission-group-panel .permission-group-left .permission-group-list li{color:#303133;padding:15px 85px 15px 10px;border-bottom:1px solid #ebeef5;position:relative}.permission-group .permission-group-panel .permission-group-left .permission-group-list li:last-child{border-bottom-width:0}.permission-group .permission-group-panel .permission-group-left .permission-group-list li.active,.permission-group .permission-group-panel .permission-group-left .permission-group-list li:hover{background-color:#ebeef5;cursor:pointer}.permission-group .permission-group-panel .permission-group-left .permission-group-list li.active{color:#409eff}.permission-group .permission-group-panel .permission-group-left .permission-group-list li .permission-group-list-button{position:absolute;right:10px;top:5px;display:none}.permission-group .permission-group-panel .permission-group-left .permission-group-list li:hover .permission-group-list-button{display:block}.permission-group .permission-group-panel .permission-group-left .permission-group-list li .el-badge{width:-webkit-max-content;width:-moz-max-content;width:max-content}.permission-group .permission-group-panel .permission-group-left .permission-group-list li .el-badge__content{right:-3px;top:8px}.permission-group .permission-group-panel .permission-group-right{width:100%;height:100%}.permission-group .permission-group-panel .permission-group-right .permission-list{padding:15px}.permission-group .permission-group-panel .permission-group-right .permission-list .el-checkbox{margin-bottom:10px;margin-left:0;margin-right:10px}.permission-group .permission-group-footer{margin-top:10px}", "", {"version":3,"sources":["/workspace/src/views/permission-group/components/PermissionGroupSelect.vue"],"names":[],"mappings":"AACA,0CAA0C,yBAAyB,iBAAiB,CACnF,AACD,mEAAmE,cAAc,yBAAyB,eAAe,kBAAkB,gCAAgC,iBAAiB,CAC3L,AACD,mGAAmG,kBAAkB,WAAW,OAAO,CACtI,AACD,iEAAiE,YAAY,8BAA8B,CAC1G,AACD,gFAAgF,SAAS,CACxF,AACD,wFAAwF,UAAU,SAAS,oBAAoB,CAC9H,AACD,2FAA2F,cAAc,4BAA4B,gCAAgC,iBAAiB,CACrL,AACD,sGAAsG,qBAAqB,CAC1H,AACD,mMAAmM,yBAAyB,cAAc,CACzO,AACD,kGAAkG,aAAa,CAC9G,AACD,yHAAyH,kBAAkB,WAAW,QAAQ,YAAY,CACzK,AACD,+HAA+H,aAAa,CAC3I,AACD,qGAAqG,0BAA0B,uBAAuB,iBAAiB,CACtK,AACD,8GAA8G,WAAW,OAAO,CAC/H,AACD,kEAAkE,WAAW,WAAW,CACvF,AACD,mFAAmF,YAAY,CAC9F,AACD,gGAAgG,mBAAmB,cAAc,iBAAiB,CACjJ,AACD,2CAA2C,eAAe,CACzD","file":"PermissionGroupSelect.vue","sourcesContent":["\n.permission-group .permission-group-panel{border:1px solid #ebeef5;border-radius:4px\n}\n.permission-group .permission-group-panel .permission-group-header{color:#303133;background-color:#F2F6FC;font-size:15px;padding:14px 10px;border-bottom:1px solid #ebeef5;position:relative\n}\n.permission-group .permission-group-panel .permission-group-header .permission-group-header-button{position:absolute;right:10px;top:2px\n}\n.permission-group .permission-group-panel .permission-group-left{height:100%;border-right:1px solid #ebeef5\n}\n.permission-group .permission-group-panel .permission-group-left .el-card__body{padding:0\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list{padding:0;margin:0;list-style-type:none\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li{color:#303133;padding:15px 85px 15px 10px;border-bottom:1px solid #ebeef5;position:relative\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li:last-child{border-bottom-width:0\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li:hover,.permission-group .permission-group-panel .permission-group-left .permission-group-list li.active{background-color:#EBEEF5;cursor:pointer\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li.active{color:#409EFF\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li .permission-group-list-button{position:absolute;right:10px;top:5px;display:none\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li:hover .permission-group-list-button{display:block\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li .el-badge{width:-webkit-max-content;width:-moz-max-content;width:max-content\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li .el-badge__content{right:-3px;top:8px\n}\n.permission-group .permission-group-panel .permission-group-right{width:100%;height:100%\n}\n.permission-group .permission-group-panel .permission-group-right .permission-list{padding:15px\n}\n.permission-group .permission-group-panel .permission-group-right .permission-list .el-checkbox{margin-bottom:10px;margin-left:0;margin-right:10px\n}\n.permission-group .permission-group-footer{margin-top:10px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2065:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2066);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("0c09aa04", content, true, {});

/***/ }),

/***/ 2066:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PermissionGroupSelect.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2067:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2068);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("a06db038", content, true, {});

/***/ }),

/***/ 2068:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PermissionGroupSelect.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 2069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"permission-group"},[_c('el-container',{staticClass:"permission-group-panel",style:({ height: _vm.height + 'px' })},[_c('div',{staticClass:"permission-group-left"},[_c('div',{staticClass:"permission-group-header"},[_c('b',[_vm._v("权限组")])]),_vm._v(" "),_c('el-scrollbar',{style:({ height: _vm.height - 48 + 'px' }),attrs:{"wrap-style":"overflow-x: hidden;"}},[_c('ul',{staticClass:"permission-group-list"},_vm._l((_vm.permissionGroupList),function(permissionGroup,index){return _c('li',{key:index,class:[_vm.activePermissionGroup===permissionGroup?'active':''],on:{"click":function($event){return _vm.onActivePermissionGroup(permissionGroup)}}},[_c('el-badge',{attrs:{"value":_vm.getSelected(permissionGroup).length + '/' + permissionGroup.permission_ids.length}},[_vm._v("\n              "+_vm._s(permissionGroup.name)+"\n            ")])],1)}),0)])],1),_vm._v(" "),_c('div',{staticClass:"permission-group-right"},[_c('div',{staticClass:"permission-group-header"},[_c('b',[_vm._v("权限分配")])]),_vm._v(" "),_c('el-scrollbar',{style:({ height: _vm.height - 48 + 'px' }),attrs:{"wrap-style":"overflow-x: hidden;"}},[_c('div',{staticClass:"permission-list"},[(_vm.activePermissionGroup)?_c('el-checkbox',{directives:[{name:"show",rawName:"v-show",value:(_vm.activePermissionGroup.permissions.length > 1),expression:"activePermissionGroup.permissions.length > 1"}],attrs:{"indeterminate":_vm.isIndeterminate,"border":"","size":"medium"},on:{"change":_vm.handleCheckAllChange},model:{value:(_vm.checkAll),callback:function ($$v) {_vm.checkAll=$$v},expression:"checkAll"}},[_vm._v("全选\n          ")]):_vm._e(),_vm._v(" "),(_vm.activePermissionGroup)?_c('el-checkbox-group',{on:{"change":_vm.handleCheckedChange},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},_vm._l((_vm.activePermissionGroup.permissions),function(ref){
var id = ref.id;
return _c('el-checkbox',{key:_vm.permissionListMap[id].id,attrs:{"label":_vm.permissionListMap[id].id,"disabled":_vm.permissionListMap[id].disabled,"border":"","size":"medium"},on:{"change":function (event) { return _vm.onChange(event, id); }}},[_vm._v(_vm._s(_vm.permissionListMap[id].name)+"\n            ")])}),1):_vm._e()],1)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2886:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_permission_group_pages_PermissionGroupDialog__ = __webpack_require__(5071);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PermissionGroupDialog: __WEBPACK_IMPORTED_MODULE_4__views_permission_group_pages_PermissionGroupDialog__["a" /* default */], draggable: __WEBPACK_IMPORTED_MODULE_3_vuedraggable___default.a },
  data: function data() {
    return {
      activePermissionGroup: null,
      permissionGroupList: [],
      permissionList: [],
      permissionListMap: {},
      permissionUnselectedList: [],

      activeName: '',
      platformlist: [],
      currentPlatform: {},
      activeIndex: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    clientHeight: function clientHeight(state) {
      return state.clientHeight;
    }
  }), {
    height: function height() {
      var height = this.clientHeight - 250;
      if (height < 300) {
        height = 300;
      }
      return height;
    }
  }),
  watch: {},
  created: function created() {
    var _this = this;

    this.fetchPlatformlist().then(function (data) {
      _this.netFetchData(data, 0);
    });
  },
  mounted: function mounted() {},

  methods: {
    fetchPlatformlist: function fetchPlatformlist() {
      var _this2 = this;

      return request.common('getPermissionPlatformlist', {}).then(function (_ref) {
        var _platformlist;

        var data = _ref.data;

        _this2.activeName = data.main.name;
        _this2.platformlist.push(data.main);
        (_platformlist = _this2.platformlist).push.apply(_platformlist, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(data.others));
        return data.main;
      });
    },
    handleClick: function handleClick(tab, event) {
      var platform = this.platformlist[tab.index];
      this.currentPlatform = platform;
      if (!this.platformlist[tab.index].permissionList) {
        this.activeIndex = tab.index;
        this.netFetchData(platform, tab.index);
      } else {
        this.updateActivePermission(this.activeIndex);
        this.activeIndex = tab.index;
        this.permissionGroupList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.platformlist[this.activeIndex].permissionGroupList));
        this.permissionList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.platformlist[this.activeIndex].permissionList));
        this.permissionUnselectedList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.platformlist[this.activeIndex].permissionUnselectedList));
        this.permissionListMap = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.platformlist[this.activeIndex].permissionListMap);
        // this.activePermissionGroup = {...this.platformlist[this.activeIndex].activePermissionGroup}
        this.activePermissionGroup = this.permissionGroupList[0];
      }
    },
    netFetchData: function netFetchData(platform, activeIndex) {
      var _this3 = this;

      this.permissionGroupList = [];
      this.permissionList = [];
      this.permissionListMap = {};
      this.permissionUnselectedList = [];
      request.all.common([request('getPermissionTable', { host: platform.host, per_page: 666 }), request('getPermissionGroupTable', { host: platform.host })]).then(function (res) {
        // 权限列表
        _this3.permissionList = res[0].data.data;
        _this3.permissionListMap = {};
        _this3.permissionList.forEach(function (permission) {
          permission.selected = false;
          _this3.permissionListMap[permission.id] = permission;
        });
        // 权限组列表
        var permissionGroupList = res[1].data.data;
        // 处理权限组列表
        permissionGroupList.forEach(function (group) {
          group.permission_ids = [];
          group.permissions.forEach(function (_ref2) {
            var id = _ref2.id;

            group.permission_ids.push(id);
            // 标记已选择
            _this3.permissionListMap[id].selected = true;
          });
          delete group.permissions;
        });
        // 获得未选择权限列表
        _this3.permissionList.forEach(function (permission) {
          !permission.selected && _this3.permissionUnselectedList.push(permission.id);
        });
        _this3.permissionGroupList = permissionGroupList;
        // 默认活跃权限组
        _this3.activePermissionGroup = permissionGroupList[0];
        _this3.updateActivePermission(activeIndex);
        _this3.platformlist[activeIndex].oldPermissionGroupList = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this3.permissionGroupList));
      });
    },
    updateActivePermission: function updateActivePermission(activeIndex) {
      this.platformlist[activeIndex].permissionGroupList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.permissionGroupList));
      this.platformlist[activeIndex].permissionList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.permissionList));
      this.platformlist[activeIndex].permissionUnselectedList = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.permissionUnselectedList));
      this.platformlist[activeIndex].permissionListMap = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.permissionListMap);
      // this.platformlist[activeIndex].activePermissionGroup = {...this.activePermissionGroup}
    },
    chekChangePermissionGroup: function chekChangePermissionGroup(_ref3) {
      var permissionGroupList = _ref3.permissionGroupList,
          oldPermissionGroupList = _ref3.oldPermissionGroupList;

      if (permissionGroupList.length !== oldPermissionGroupList.length) {
        return true;
      }
      for (var index = 0; index < permissionGroupList.length; index++) {
        var permission = permissionGroupList[index];
        var oldPermission = oldPermissionGroupList[index];
        var ids = permission.permission_ids.sort(function (a, b) {
          return a - b;
        }).join(',');
        var oldIds = oldPermission.permission_ids.sort(function (a, b) {
          return a - b;
        }).join(',');
        if (ids !== oldIds) {
          return true;
        }
      }
      return false;
    },
    onSave: function onSave() {
      var _this4 = this;

      this.updateActivePermission(this.activeIndex);
      var requests = this.platformlist.filter(function (platform) {
        if (platform.permissionGroupList && _this4.chekChangePermissionGroup(platform)) {
          return request('savePermissionGroupData', { host: platform.host, group_list: platform.permissionGroupList });
        }
      });
      request.all.common(requests).then(function () {
        _this4.$alert('权限组保存成功！', '提示', { type: 'success' });
      });
    },
    create: function create() {
      var _this5 = this;

      this.$refs['permission-group-dialog'].create(function (group) {
        group.permission_ids = [];
        group.permissions.forEach(function (_ref4) {
          var id = _ref4.id;

          group.permission_ids.push(id);
        });
        _this5.permissionGroupList.push(group);
      });
    },
    update: function update(group) {
      this.$refs['permission-group-dialog'].update(function (data) {
        group.name = data.name;
      }, group);
    },
    remove: function remove(id, index) {
      var _this6 = this;

      this.$confirm('此操作将永久删除该权限组, 是否继续?', '提示', { type: 'warning' }).then(function () {
        request.common('deletePermissionGroupData', { host: _this6.currentPlatform.host, id: id }).then(function (_ref5) {
          var data = _ref5.data;

          _this6.permissionGroupList.splice(index, 1);
          _this6.$message.success('删除权限组成功');
        });
      }).catch(function () {
        _this6.$message.info('已取消删除');
      });
    },
    onActivePermissionGroup: function onActivePermissionGroup(group) {
      this.activePermissionGroup = group;
    },
    onChangeSelectedPermissionList: function onChangeSelectedPermissionList(val, id) {
      this.permissionListMap[id].selected = val;
      if (val) {
        this.permissionUnselectedList.splice(this.permissionUnselectedList.indexOf(id), 1);
      } else {
        this.permissionUnselectedList.push(id);
      }
    }
  }
});

/***/ }),

/***/ 2887:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: {
    platformHost: {
      type: String
    }
  },
  data: function data() {
    return {
      title: '',
      callback: Function.prototype,
      visible: false,
      form: {
        id: null,
        name: null,
        permission_ids: []
      }
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    create: function create(callback) {
      this.form.id = null;
      this.form.name = null;
      this.form.permission_ids = [];
      this.title = '添加权限组';
      this.callback = callback;
      this.visible = true;
    },
    update: function update(callback, data) {
      this.form.id = data.id;
      this.form.name = data.name;
      this.form.permission_ids = data.permission_ids;
      this.title = '修改权限组';
      this.callback = callback;
      this.visible = true;
    },
    onSubmit: function onSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this.form.id ? _this.updateRequest() : _this.createRequest();
        } else {
          _this.$message.error('提交内容填写不正确！');
        }
      });
    },
    createRequest: function createRequest() {
      var _this2 = this;

      request.common('createPermissionGroupData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.form, { host: this.platformHost })).then(function (_ref) {
        var data = _ref.data;

        _this2.$message.success('创建权限组成功！');
        _this2.callback(data);
        _this2.visible = false;
      });
    },
    updateRequest: function updateRequest() {
      var _this3 = this;

      request.common('updatePermissionGroupData', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.form, { host: this.platformHost })).then(function (_ref2) {
        var data = _ref2.data;

        _this3.$message.success('修改权限组成功！');
        _this3.callback(data);
        _this3.visible = false;
      });
    }
  }
});

/***/ }),

/***/ 2888:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_permission_group_components_PermissionGroupSelect__ = __webpack_require__(2062);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { PermissionGroupSelect: __WEBPACK_IMPORTED_MODULE_0__views_permission_group_components_PermissionGroupSelect__["a" /* default */] },
  data: function data() {
    return {
      disabled: [4, 6, 14, 2],
      permissions: [4, 6, 14, 2]
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onChange: function onChange(val) {
      console.log(val);
    }
  }
});

/***/ }),

/***/ 5065:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5066);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3b9e0120", content, true, {});

/***/ }),

/***/ 5066:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".permission-group .permission-group-panel{border:1px solid #ebeef5;border-radius:4px}.permission-group .permission-group-panel .permission-group-header{color:#303133;background-color:#f2f6fc;font-size:15px;padding:14px 10px;border-bottom:1px solid #ebeef5;position:relative}.permission-group .permission-group-panel .permission-group-header .permission-group-header-button{position:absolute;right:10px;top:2px}.permission-group .permission-group-panel .permission-group-left{height:100%;border-right:1px solid #ebeef5}.permission-group .permission-group-panel .permission-group-left .el-card__body{padding:0}.permission-group .permission-group-panel .permission-group-left .permission-group-list{padding:0;margin:0;list-style-type:none}.permission-group .permission-group-panel .permission-group-left .permission-group-list li{color:#303133;padding:15px 85px 15px 10px;border-bottom:1px solid #ebeef5;position:relative}.permission-group .permission-group-panel .permission-group-left .permission-group-list li:last-child{border-bottom-width:0}.permission-group .permission-group-panel .permission-group-left .permission-group-list li.active,.permission-group .permission-group-panel .permission-group-left .permission-group-list li:hover{background-color:#ebeef5;cursor:pointer}.permission-group .permission-group-panel .permission-group-left .permission-group-list li.active{color:#409eff}.permission-group .permission-group-panel .permission-group-left .permission-group-list li .permission-group-list-button{position:absolute;right:10px;top:5px;display:none}.permission-group .permission-group-panel .permission-group-left .permission-group-list li:hover .permission-group-list-button{display:block}.permission-group .permission-group-panel .permission-group-left .permission-group-list li .el-badge{width:-webkit-max-content;width:-moz-max-content;width:max-content}.permission-group .permission-group-panel .permission-group-left .permission-group-list li .el-badge__content{right:-3px;top:8px}.permission-group .permission-group-panel .permission-group-right{width:100%;height:100%}.permission-group .permission-group-panel .permission-group-right .permission-list{padding:15px}.permission-group .permission-group-panel .permission-group-right .permission-list .el-checkbox{margin-bottom:10px;margin-left:0;margin-right:10px}.permission-group .permission-group-footer{margin-top:10px}", "", {"version":3,"sources":["/workspace/src/views/permission-group/pages/PermissionGroupManage.vue"],"names":[],"mappings":"AACA,0CAA0C,yBAAyB,iBAAiB,CACnF,AACD,mEAAmE,cAAc,yBAAyB,eAAe,kBAAkB,gCAAgC,iBAAiB,CAC3L,AACD,mGAAmG,kBAAkB,WAAW,OAAO,CACtI,AACD,iEAAiE,YAAY,8BAA8B,CAC1G,AACD,gFAAgF,SAAS,CACxF,AACD,wFAAwF,UAAU,SAAS,oBAAoB,CAC9H,AACD,2FAA2F,cAAc,4BAA4B,gCAAgC,iBAAiB,CACrL,AACD,sGAAsG,qBAAqB,CAC1H,AACD,mMAAmM,yBAAyB,cAAc,CACzO,AACD,kGAAkG,aAAa,CAC9G,AACD,yHAAyH,kBAAkB,WAAW,QAAQ,YAAY,CACzK,AACD,+HAA+H,aAAa,CAC3I,AACD,qGAAqG,0BAA0B,uBAAuB,iBAAiB,CACtK,AACD,8GAA8G,WAAW,OAAO,CAC/H,AACD,kEAAkE,WAAW,WAAW,CACvF,AACD,mFAAmF,YAAY,CAC9F,AACD,gGAAgG,mBAAmB,cAAc,iBAAiB,CACjJ,AACD,2CAA2C,eAAe,CACzD","file":"PermissionGroupManage.vue","sourcesContent":["\n.permission-group .permission-group-panel{border:1px solid #ebeef5;border-radius:4px\n}\n.permission-group .permission-group-panel .permission-group-header{color:#303133;background-color:#F2F6FC;font-size:15px;padding:14px 10px;border-bottom:1px solid #ebeef5;position:relative\n}\n.permission-group .permission-group-panel .permission-group-header .permission-group-header-button{position:absolute;right:10px;top:2px\n}\n.permission-group .permission-group-panel .permission-group-left{height:100%;border-right:1px solid #ebeef5\n}\n.permission-group .permission-group-panel .permission-group-left .el-card__body{padding:0\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list{padding:0;margin:0;list-style-type:none\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li{color:#303133;padding:15px 85px 15px 10px;border-bottom:1px solid #ebeef5;position:relative\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li:last-child{border-bottom-width:0\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li:hover,.permission-group .permission-group-panel .permission-group-left .permission-group-list li.active{background-color:#EBEEF5;cursor:pointer\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li.active{color:#409EFF\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li .permission-group-list-button{position:absolute;right:10px;top:5px;display:none\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li:hover .permission-group-list-button{display:block\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li .el-badge{width:-webkit-max-content;width:-moz-max-content;width:max-content\n}\n.permission-group .permission-group-panel .permission-group-left .permission-group-list li .el-badge__content{right:-3px;top:8px\n}\n.permission-group .permission-group-panel .permission-group-right{width:100%;height:100%\n}\n.permission-group .permission-group-panel .permission-group-right .permission-list{padding:15px\n}\n.permission-group .permission-group-panel .permission-group-right .permission-list .el-checkbox{margin-bottom:10px;margin-left:0;margin-right:10px\n}\n.permission-group .permission-group-footer{margin-top:10px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5067:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5068);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("9f511814", content, true, {});

/***/ }),

/***/ 5068:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PermissionGroupManage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5069:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5070);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7305d56a", content, true, {});

/***/ }),

/***/ 5070:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PermissionGroupManage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5071:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionGroupDialog_vue__ = __webpack_require__(2887);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33fd861d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionGroupDialog_vue__ = __webpack_require__(5078);
function injectStyle (ssrContext) {
  __webpack_require__(5072)
  __webpack_require__(5074)
  this["$style"] = __webpack_require__(5076)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33fd861d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionGroupDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33fd861d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionGroupDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 5072:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5073);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("7f73d988", content, true, {});

/***/ }),

/***/ 5073:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PermissionGroupDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5074:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5075);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3235831a", content, true, {});

/***/ }),

/***/ 5075:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PermissionGroupDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5076:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5077);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("10a430f4", content, true, {});

/***/ }),

/***/ 5077:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PermissionGroupDialog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5078:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.visible,"width":"500px"},on:{"update:visible":function($event){_vm.visible=$event}},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onSubmit()}}},[_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"60px"}},[_c('el-form-item',{attrs:{"label":"组名称","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"权限组名称"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.visible = false}}},[_vm._v("取 消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":!_vm.form.name},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("确 定")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5079:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"permission-group"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("权限组管理")]),_vm._v(" "),_c('el-tabs',{attrs:{"type":"card"},on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},_vm._l((_vm.platformlist),function(platform,index){return _c('el-tab-pane',{key:index,attrs:{"label":platform.name + '管理',"name":platform.name}},[_c('el-container',{staticClass:"permission-group-panel",style:({ height: _vm.height + 'px' })},[_c('div',{staticClass:"permission-group-left"},[_c('div',{staticClass:"permission-group-header"},[_c('b',[_vm._v("权限组")]),_vm._v(" "),_c('div',{staticClass:"permission-group-header-button"},[_c('el-button',{attrs:{"type":"text","icon":"el-icon-plus"},on:{"click":function($event){return _vm.create()}}})],1)]),_vm._v(" "),_c('el-scrollbar',{style:({ height: _vm.height - 48 + 'px' }),attrs:{"wrap-style":"overflow-x: hidden;"}},[_c('ul',{staticClass:"permission-group-list"},[_c('draggable',{attrs:{"options":{handle: '', disabled: false, scrollSensitivity: 60, scrollSpeed: 20}},on:{"update":function($event){}},model:{value:(_vm.permissionGroupList),callback:function ($$v) {_vm.permissionGroupList=$$v},expression:"permissionGroupList"}},_vm._l((_vm.permissionGroupList),function(permissionGroup,index){return _c('li',{class:[_vm.activePermissionGroup===permissionGroup?'active':''],on:{"click":function($event){return _vm.onActivePermissionGroup(permissionGroup)}}},[_c('el-badge',{attrs:{"value":permissionGroup.permission_ids.length}},[_vm._v("\n                  "+_vm._s(permissionGroup.name)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"permission-group-list-button"},[_c('el-button',{attrs:{"type":"text","icon":"el-icon-edit-outline"},on:{"click":function($event){return _vm.update(permissionGroup)}}}),_vm._v(" "),_c('el-button',{attrs:{"type":"text","icon":"el-icon-delete"},on:{"click":function($event){return _vm.remove(permissionGroup.id, index)}}})],1)],1)}),0)],1)])],1),_vm._v(" "),_c('div',{staticClass:"permission-group-right"},[_c('div',{staticClass:"permission-group-header"},[_c('b',[_vm._v("权限分配")]),_vm._v(" "),_c('small',{staticStyle:{"color":"#606266"}},[_vm._v(" 未分配 "+_vm._s(_vm.permissionUnselectedList.length))])]),_vm._v(" "),_c('el-scrollbar',{style:({ height: _vm.height - 48 + 'px' }),attrs:{"wrap-style":"overflow-x: hidden;"}},[_c('div',{staticClass:"permission-list"},[(_vm.activePermissionGroup)?_c('el-checkbox-group',{model:{value:(_vm.activePermissionGroup.permission_ids),callback:function ($$v) {_vm.$set(_vm.activePermissionGroup, "permission_ids", $$v)},expression:"activePermissionGroup.permission_ids"}},[_c('draggable',{attrs:{"options":{handle: '', disabled: false, scrollSensitivity: 60, scrollSpeed: 20}},on:{"update":function($event){}},model:{value:(_vm.activePermissionGroup.permission_ids),callback:function ($$v) {_vm.$set(_vm.activePermissionGroup, "permission_ids", $$v)},expression:"activePermissionGroup.permission_ids"}},_vm._l((_vm.activePermissionGroup.permission_ids),function(id){return _c('el-checkbox',{key:_vm.permissionListMap[id].id,attrs:{"label":_vm.permissionListMap[id].id,"border":"","size":"medium"},on:{"change":function (event) { return _vm.onChangeSelectedPermissionList(event, id); }}},[_vm._v(_vm._s(_vm.permissionListMap[id].name)+"\n                ")])}),1)],1):_vm._e(),_vm._v(" "),(_vm.activePermissionGroup)?_c('el-checkbox-group',{model:{value:(_vm.activePermissionGroup.permission_ids),callback:function ($$v) {_vm.$set(_vm.activePermissionGroup, "permission_ids", $$v)},expression:"activePermissionGroup.permission_ids"}},_vm._l((_vm.permissionList),function(permission){return _c('el-checkbox',{directives:[{name:"show",rawName:"v-show",value:(!permission.selected),expression:"!permission.selected"}],key:permission.id,attrs:{"label":permission.id,"border":"","size":"medium"},on:{"change":function (event) { return _vm.onChangeSelectedPermissionList(event, permission.id); }}},[_vm._v(_vm._s(permission.name)+"\n              ")])}),1):_vm._e()],1)])],1)])],1)}),1),_vm._v(" "),_c('div',{staticClass:"permission-group-footer"},[_c('el-button',{attrs:{"type":"primary","size":"medium"},on:{"click":function($event){return _vm.onSave()}}},[_vm._v("保 存\n      ")])],1)],1),_vm._v(" "),_c('permission-group-dialog',{ref:"permission-group-dialog",attrs:{"platformHost":_vm.currentPlatform.host}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 5080:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5081);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("1182a9e8", content, true, {});

/***/ }),

/***/ 5081:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PermissionGroupSelectDemo.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5082:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5083);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("4ff1b10a", content, true, {});

/***/ }),

/***/ 5083:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PermissionGroupSelectDemo.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5084:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5085);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5f5a9556", content, true, {});

/***/ }),

/***/ 5085:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"PermissionGroupSelectDemo.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5086:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"permission-group"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("权限组选择")]),_vm._v(" "),_c('permission-group-select',{attrs:{"disabled":_vm.disabled},on:{"change":_vm.onChange},model:{value:(_vm.permissions),callback:function ($$v) {_vm.permissions=$$v},expression:"permissions"}}),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.disabled))]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.permissions))])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/permission-group-manage.95184398b65806244c4b.js